import { FC, memo } from 'react';
import classNames from 'classnames';

import { TopBannerState } from 'application/components/widgets/TopBanner/useTopBannerState';
import { RouterUtils, useNavigate } from 'application/providers/RouterProvider';
import { BILLING_PAGE_PATH, StateParamValues } from 'application/pages/BillingPage';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';

import { TEXTS } from '../texts';

import styles from '../index.module.scss';

interface PaymentSchemaBannerProps {
  className?: string;
  banner: TopBannerState;
  formatNextBillingDate: string;
  formatStartNewSchemeDate: string;
  monthGenitive: string;
}

const billingPageLinkTo = RouterUtils.generatePath(BILLING_PAGE_PATH, { state: StateParamValues.INFO });

const PAYMENT_SCHEME_CALENDAR_PATH = '/assets/img/banner/billing_payment_scheme_calendar.png';

const PaymentSchemaBanner: FC<PaymentSchemaBannerProps> = ({
  banner,
  className,
  formatNextBillingDate,
  formatStartNewSchemeDate,
  monthGenitive,
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={classNames(styles.TopBanner, className)}
      data-type={banner.type}>
      <img
        src={PAYMENT_SCHEME_CALENDAR_PATH}
        alt=""
        loading="lazy"
        className={styles.TopBannerPaymentSchemeCalendar}
      />

      <div className={styles.TopBannerLeftText}>
        <div className={styles.TopBannerDescription}>
          {TEXTS.BANNER_PAYMENT_SCHEME_TEXT_1(formatStartNewSchemeDate)}
        </div>
        <div className={styles.TopBannerDescription}>
          {TEXTS.BANNER_PAYMENT_SCHEME_TEXT_2(formatNextBillingDate, monthGenitive)}
        </div>
      </div>

      <Button
        elementId="payment_scheme_banner_button_go_to_billing"
        type={ButtonType.PLAIN}
        className={styles.TopBannerButton}
        onClick={() => navigate(billingPageLinkTo)}>
        {TEXTS.BUTTON_GO_TO_BILLING_VARIANT_TITLE_PAYMENT_SCHEME}
      </Button>
    </div>
  );
};

export default memo(PaymentSchemaBanner);
